//@ts-check
import { error } from '@react/react-spectrum/Toast/js/ToastContainer';

import { commonApi, handleApiCall } from '@exchange-frontends/api';

export async function getStaticData(slice = 'All') {
  const handler = handleApiCall(commonApi.staticData, {
    slice,
  });
  try {
    return await handler.run();
  } catch (err) {
    if (err.code !== 20) {
      error(err.userMessage, { timeout: 0 });
      console.error(err);
    }
  }
}
